module.exports = __webpack_public_path__ + "img/menu5.5666a92a.svg";